import React from 'react'

import ComponentError from '../../components/display/ComponentError'
import {
  Outerwrapper,
  StickyBar,
  ResultsArea,
  MapContainer,
} from '../../components/layout/ItemGridWithMap/Desktop'

type DesktopViewProps = {
  filterBarComponent: React.ReactNode
  resultsComponent: React.ReactNode
  mapComponent: React.ReactNode
}

const DesktopView = ({
  filterBarComponent,
  resultsComponent,
  mapComponent,
}: DesktopViewProps) => {
  return (
    <Outerwrapper className="js-global-loader-container">
      <StickyBar>
        {filterBarComponent}
        <MapContainer>
          <ComponentError>{mapComponent}</ComponentError>
        </MapContainer>
      </StickyBar>
      <ResultsArea>
        <ComponentError>{resultsComponent}</ComponentError>
      </ResultsArea>
    </Outerwrapper>
  )
}

export default DesktopView
